import React, { useRef } from "react"

import useTracking from "hooks/useTracking"

import { CardContainer, EquipmentName, PriceReference, CardImage } from "./styles"

const Card = ({ image, price, name, url, source, index, onFocus }) => {
  const { trackClick } = useTracking()
  const refClick = useRef(null)

  const trackingId = `Equipment ${name}`
  const trackingProps = {
    label: trackingId,
    product: name,
    price,
  }

  if (url) {
    trackClick(refClick, trackingId, trackingProps)
  }

  return (
    <CardContainer
      ref={refClick}
      onFocus={() => onFocus(index)}
      index={index}
      href={url}
      target="_blank"
    >
      <CardImage
        fetchpriority="low"
        baseUrl={image.path}
        images={[
          {
            transforms: "c_fill,g_auto,w_176,h_176,q_auto,f_auto,fl_lossy,bo_20px_solid_white",
          },
        ]}
        alt={name}
      />
      <EquipmentName>{name}</EquipmentName>
      <PriceReference>
        ${price} {source}
      </PriceReference>
    </CardContainer>
  )
}

export default Card
